// extracted by mini-css-extract-plugin
module.exports = {"mainRow":"TabMainRow_mainRow__fXI0C"};